import { createSlice } from '@reduxjs/toolkit';

const flavorsSlice = createSlice({
  name: 'flavors',
  initialState: {
    items: {},  // Using an object for O(1) lookups
    loading: false,
    error: null
  },
  reducers: {
    updateFlavorInState: (state, action) => {
      const updatedFlavor = action.payload;
      // Update the flavor in our lookup object and ensure it triggers a state update
      state.items = {
        ...state.items,
        [updatedFlavor.id]: updatedFlavor
      };
    },
    setFlavors: (state, action) => {
      // Convert array to lookup object and ensure it triggers a state update
      const newItems = action.payload.reduce((acc, flavor) => {
        acc[flavor.id] = flavor;
        return acc;
      }, {});
      state.items = newItems;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { updateFlavorInState, setFlavors, setLoading, setError } = flavorsSlice.actions;
export default flavorsSlice.reducer;